import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import { useNavigate } from "react-router-dom";
export default function WhyWorkWithUsSection({ sectionTitle }) {
  const items = [
    { 
      title: 'Free Expert Case Evaluation', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path></svg> 
    },
    { 
      title: 'Precision-Driven Treatment Planning', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="14" rx="2"></rect><path d="M8 21h8"></path><path d="M12 17v4"></path></svg> 
    },
    { 
      title: 'Predictable Clinical Outcomes', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg> 
    },
    { 
      title: 'Enhanced Workflow Efficiency', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"></rect><circle cx="12" cy="12" r="2"></circle><path d="M6 12h.01M18 12h.01"></path></svg> 
    },
    { 
      title: 'No Monthly Subscription Required', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9 0"></path></svg> 
    },
    { 
      title: 'Increased Case Acceptance & Practice Profitability', 
      icon: <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg> 
    },
  ];
const navigate = useNavigate();
  return (
    <div className="container">
      <SectionHeading title={sectionTitle} center />
      <Spacing md="72" lg="50" />
      <div className="row">
        {items.map((item, index) => (
          <div className="col-lg-4 col-md-6 mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            <div 
              className="cs_white_bg cs_radius_25 cs_shadow_1 d-flex align-items-center h-100 why-work-card"
              style={{
                padding: '24px', 
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: '1px solid transparent',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.05)';
              }}
            >
              <div 
                className="cs_accent_bg d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: '60px', height: '60px', flexShrink: 0, marginRight: '20px' }}
              >
                {item.icon}
              </div>
              <h3 className="cs_fs_20 cs_semibold m-0">{item.title}</h3>
            </div>
          </div>
        ))}

      </div>
      <div className="col-lg-12 justify-content-center d-flex mt-5" data-aos="fade-up" data-aos-delay={items.length * 100}>
          <button className="cs_btn cs_style_1" type="button"  onClick={() => navigate("/free-clear-aligner-case-evaluation")}>
           <span>Book A Call</span> 
            <i>
             
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  
             
            </i>
          </button>
        </div>
      
    </div>
  );
}
